module.exports = __webpack_public_path__ + "img/sample-report-en_CA.52ba2abb.png";